// export const ROLES = {
//     Employee: 'Employee',
//     Manager: 'Manager',
//     Admin: 'Admin',
//     Klijet: 'Klijent'
// }

export const ROLES = {
  Admin: "Admin", //Vlasnik firme
  Klijent: "Klijent",
  Korisnik: "Korisnik",
};
